// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 1) The overlay wrapper covers the full viewport */
.banner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* Semi-transparent black overlay to dim background */
  background-color: rgba(0, 0, 0, 0.5);

  /* Place behind the banner but above everything else on the page */
  z-index: 9998;
}

/* 2) The actual slanted banner is on top of the overlay */
.trial-banner {
  position: absolute;
  top: 25%;   /* Adjust as needed */
  left: 0;
  width: 100%;

  /* Dark greenish tone */
  background-color: #144044;
  color: #dcca98;

  /* Slant the banner slightly */
  transform: skewY(-3deg);
  transform-origin: top left;

  border: 4px double #dcca98;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  /* Extra padding so text isn't cut off due to the skew */
  padding: 1.5rem 1rem;

  /* Above the overlay but below 9999 so the content inside can have 9999+ if needed */
  z-index: 9999;
}

  /* -----------------------------------------
     Slanted Banner Content Wrapper (un-skew)
     ----------------------------------------- */
  .banner-content {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  
    /* Reverse the skew so child elements appear straight */
    transform: skewY(3deg);
  
    /* Center content in a column */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  
    min-height: 140px;    /* Increase for a taller banner if desired */
    text-align: center;   /* Center text within the flex column */
  }
  
  /* -------------------------------------
     Optional Darkened Overlay Background
     ------------------------------------- */
  .trial-banner::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.1; /* Adjust to taste for darker or lighter overlay */
    z-index: 1;   /* Sits behind text and shapes, but over the base color */
    pointer-events: none;
  }
  
  /* ---------------------
     Abstract Shapes Layer
     --------------------- */
  .shapes-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden; /* hides parts of shapes extending beyond the banner */
    z-index: 2;       /* behind the text/container but above the dark overlay */
  }
  
  .shape {
    position: absolute;
    opacity: 0.3;            /* Semi-transparent so text remains legible */
    background-color: #dcca98; /* Light gold for shapes */
  }
  
  /* Example circle shape #1 */
  .circle1 {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    top: 15%;
    left: 15%;
  }
  
  /* Example circle shape #2 */
  .circle2 {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    bottom: 10%;
    right: 10%;
  }
  
  /* A “blob” shape made with border-radius & rotation */
  .blob {
    width: 350px;
    height: 150px;
    border-radius: 50% 15% 50% 15%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(15deg);
  }
  
  /* -----------------------------
     Text + CTA Container on top
     ----------------------------- */
  .text-container {
    z-index: 3; /* ensures it's above shapes and the overlay */
    padding: 0.5rem 1rem;
  }
  
  /* Highlight text (e.g., "1 WEEK") */
  .highlight-text {
    font-size: 3rem;
    font-weight: 700;
    background-color: #dcca98; /* Light gold background */
    color: #144044;            /* Dark text */
    padding: 0.3rem 0.6rem;
    border-radius: 4px;
    margin-bottom: 0.4rem;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  
  /* Main text (e.g., "FREE TRIAL") */
  .main-text {
    font-size: 2rem;   /* Larger for emphasis */
    font-weight: 800;
    line-height: 1.2;
  }
  
  /* CTA Button container (just for spacing) */
  .cta-wrapper {
    margin-top: 1rem;
  }
  
  /* CTA Button styles - Light gold background, dark text */
  .cta-button {
    background-color: #dcca98;
    color: #144044;
    border: none;
    padding: 0.8rem 1.4rem;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-size: 1rem; /* Increase for bigger button */
  }
  
  .cta-button:hover {
    background-color: #c0b085; /* Slightly darker gold on hover */
  }
  
  /* 
     Dismiss (X) button in the top-right corner of the banner
     (technically top-right corner after skew, so might appear offset—adjust as needed)
  */
  .dismiss-button {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    background: none;
    border: none;
    color: #dcca98;
    font-size: 1.5rem;
    cursor: pointer;
    transition: color 0.2s ease;
    z-index: 4; /* above shapes and text container */
  }
  
  .dismiss-button:hover {
    color: #ffffff;
  }
  
  /* "FOR A LIMITED TIME" label on the side of the banner */
  .limited-time-text {
    position: absolute;
    left: 0;
    top: 50%;
    transform: rotate(-30deg) translateY(50%);
    transform-origin: center;
  
    background-color: #dcca98; /* Light gold */
    color: #144044;           /* Dark greenish tone */
    font-weight: 700;
    padding: 0.4rem 0.6rem;
    border-radius: 4px;
    letter-spacing: 1px;
    z-index: 3; /* Above shapes but below the .text-container */
  }
  
  /* ---------------------------------
     MEDIA QUERIES FOR RESPONSIVENESS
     --------------------------------- */
  
  /* Tablet breakpoint (max-width: 768px) */
  @media (max-width: 768px) {
    .trial-banner {
      /* Move the banner up or down for smaller screens if needed */
      top: 15%;
      padding: 1rem;
    }
  
    .banner-content {
      min-height: 120px; /* Slightly smaller height */
    }
  
    /* Reduce shape sizes or hide them if they overlap content */
    .circle1 {
      width: 90px;
      height: 90px;
      top: 10%;
      left: 10%;
    }
    .circle2 {
      width: 60px;
      height: 60px;
      bottom: 10%;
      right: 10%;
    }
    .blob {
      width: 280px;
      height: 120px;
    }
  
    /* Scale text sizes slightly */
    .highlight-text {
      font-size: 2rem;
    }
    .main-text {
      font-size: 1.6rem;
    }
    .cta-button {
      font-size: 0.9rem;
      padding: 0.6rem 1rem;
    }
  
    /* Adjust "LIMITED TIME" label */
    .limited-time-text {
      font-size: 1.3rem;
      transform: rotate(-25deg) translateY(50%);
    }
  }
  
  /* Mobile breakpoint (max-width: 480px) */
  @media (max-width: 480px) {
    .trial-banner {
      padding: 1rem;
    }
  
    .banner-content {
      min-height: 100px;
    }
  
    /* If shapes cause overlap on mobile, you can hide them entirely
       or drastically reduce their size. Example: 
       .circle1, .circle2, .blob { display: none; }
    */
    .circle1 {
      width: 60px;
      height: 60px;
      top: 10%;
      left: 5%;
    }
    .circle2 {
      width: 40px;
      height: 40px;
      bottom: 5%;
      right: 5%;
    }
    .blob {
      width: 200px;
      height: 100px;
    }
  
    /* Scale text further on mobile */
    .highlight-text {
      font-size: 0.8rem;
    }
    .main-text {
      font-size: 1.4rem;
    }
    .cta-button {
      font-size: 0.8rem;
      padding: 0.5rem 0.8rem;
    }
  
    .dismiss-button {
      font-size: 1.2rem;
      top: 0.3rem;
    }
  
    /* Adjust "LIMITED TIME" label for mobile */
    .limited-time-text {
      font-size: 0.7rem;
      transform: rotate(-20deg) translateY(50%);
    }
  }
  
  /* 
     If your page content is hidden behind the banner, 
     add some top padding to the body or main container. 
     Adjust according to the final banner height.
  */
  body {
    font-family: sans-serif;
    /* Example:
    padding-top: 200px; 
    */
  }
  `, "",{"version":3,"sources":["webpack://./src/Banner/FancyBanner.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,qDAAqD;EACrD,oCAAoC;;EAEpC,kEAAkE;EAClE,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ,IAAI,qBAAqB;EACjC,OAAO;EACP,WAAW;;EAEX,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;;EAEd,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;;EAE1B,0BAA0B;EAC1B,wCAAwC;;EAExC,wDAAwD;EACxD,oBAAoB;;EAEpB,oFAAoF;EACpF,aAAa;AACf;;EAEE;;gDAE8C;EAC9C;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;;IAElB,uDAAuD;IACvD,sBAAsB;;IAEtB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,iBAAiB,KAAK,4CAA4C;IAClE,kBAAkB,IAAI,uCAAuC;EAC/D;;EAEA;;4CAE0C;EAC1C;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY,EAAE,kDAAkD;IAChE,UAAU,IAAI,yDAAyD;IACvE,oBAAoB;EACtB;;EAEA;;4BAE0B;EAC1B;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,gBAAgB,EAAE,sDAAsD;IACxE,UAAU,QAAQ,yDAAyD;EAC7E;;EAEA;IACE,kBAAkB;IAClB,YAAY,aAAa,6CAA6C;IACtE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,4BAA4B;EAC5B;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA,4BAA4B;EAC5B;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA,sDAAsD;EACtD;IACE,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,SAAS;IACT,8CAA8C;EAChD;;EAEA;;oCAEkC;EAClC;IACE,UAAU,EAAE,8CAA8C;IAC1D,oBAAoB;EACtB;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB,EAAE,0BAA0B;IACrD,cAAc,aAAa,cAAc;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA,mCAAmC;EACnC;IACE,eAAe,IAAI,wBAAwB;IAC3C,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,4CAA4C;EAC5C;IACE,gBAAgB;EAClB;;EAEA,yDAAyD;EACzD;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,eAAe,EAAE,+BAA+B;EAClD;;EAEA;IACE,yBAAyB,EAAE,kCAAkC;EAC/D;;EAEA;;;GAGC;EACD;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,UAAU,EAAE,oCAAoC;EAClD;;EAEA;IACE,cAAc;EAChB;;EAEA,yDAAyD;EACzD;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,yCAAyC;IACzC,wBAAwB;;IAExB,yBAAyB,EAAE,eAAe;IAC1C,cAAc,YAAY,uBAAuB;IACjD,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU,EAAE,+CAA+C;EAC7D;;EAEA;;wCAEsC;;EAEtC,yCAAyC;EACzC;IACE;MACE,6DAA6D;MAC7D,QAAQ;MACR,aAAa;IACf;;IAEA;MACE,iBAAiB,EAAE,4BAA4B;IACjD;;IAEA,4DAA4D;IAC5D;MACE,WAAW;MACX,YAAY;MACZ,QAAQ;MACR,SAAS;IACX;IACA;MACE,WAAW;MACX,YAAY;MACZ,WAAW;MACX,UAAU;IACZ;IACA;MACE,YAAY;MACZ,aAAa;IACf;;IAEA,8BAA8B;IAC9B;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;;IAEA,gCAAgC;IAChC;MACE,iBAAiB;MACjB,yCAAyC;IAC3C;EACF;;EAEA,yCAAyC;EACzC;IACE;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;;;KAGC;IACD;MACE,WAAW;MACX,YAAY;MACZ,QAAQ;MACR,QAAQ;IACV;IACA;MACE,WAAW;MACX,YAAY;MACZ,UAAU;MACV,SAAS;IACX;IACA;MACE,YAAY;MACZ,aAAa;IACf;;IAEA,iCAAiC;IACjC;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,iBAAiB;MACjB,WAAW;IACb;;IAEA,2CAA2C;IAC3C;MACE,iBAAiB;MACjB,yCAAyC;IAC3C;EACF;;EAEA;;;;GAIC;EACD;IACE,uBAAuB;IACvB;;KAEC;EACH","sourcesContent":["/* 1) The overlay wrapper covers the full viewport */\n.banner-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  /* Semi-transparent black overlay to dim background */\n  background-color: rgba(0, 0, 0, 0.5);\n\n  /* Place behind the banner but above everything else on the page */\n  z-index: 9998;\n}\n\n/* 2) The actual slanted banner is on top of the overlay */\n.trial-banner {\n  position: absolute;\n  top: 25%;   /* Adjust as needed */\n  left: 0;\n  width: 100%;\n\n  /* Dark greenish tone */\n  background-color: #144044;\n  color: #dcca98;\n\n  /* Slant the banner slightly */\n  transform: skewY(-3deg);\n  transform-origin: top left;\n\n  border: 4px double #dcca98;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n  /* Extra padding so text isn't cut off due to the skew */\n  padding: 1.5rem 1rem;\n\n  /* Above the overlay but below 9999 so the content inside can have 9999+ if needed */\n  z-index: 9999;\n}\n\n  /* -----------------------------------------\n     Slanted Banner Content Wrapper (un-skew)\n     ----------------------------------------- */\n  .banner-content {\n    max-width: 1200px;\n    margin: 0 auto;\n    position: relative;\n  \n    /* Reverse the skew so child elements appear straight */\n    transform: skewY(3deg);\n  \n    /* Center content in a column */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  \n    min-height: 140px;    /* Increase for a taller banner if desired */\n    text-align: center;   /* Center text within the flex column */\n  }\n  \n  /* -------------------------------------\n     Optional Darkened Overlay Background\n     ------------------------------------- */\n  .trial-banner::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #000;\n    opacity: 0.1; /* Adjust to taste for darker or lighter overlay */\n    z-index: 1;   /* Sits behind text and shapes, but over the base color */\n    pointer-events: none;\n  }\n  \n  /* ---------------------\n     Abstract Shapes Layer\n     --------------------- */\n  .shapes-bg {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    overflow: hidden; /* hides parts of shapes extending beyond the banner */\n    z-index: 2;       /* behind the text/container but above the dark overlay */\n  }\n  \n  .shape {\n    position: absolute;\n    opacity: 0.3;            /* Semi-transparent so text remains legible */\n    background-color: #dcca98; /* Light gold for shapes */\n  }\n  \n  /* Example circle shape #1 */\n  .circle1 {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    top: 15%;\n    left: 15%;\n  }\n  \n  /* Example circle shape #2 */\n  .circle2 {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    bottom: 10%;\n    right: 10%;\n  }\n  \n  /* A “blob” shape made with border-radius & rotation */\n  .blob {\n    width: 350px;\n    height: 150px;\n    border-radius: 50% 15% 50% 15%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) rotate(15deg);\n  }\n  \n  /* -----------------------------\n     Text + CTA Container on top\n     ----------------------------- */\n  .text-container {\n    z-index: 3; /* ensures it's above shapes and the overlay */\n    padding: 0.5rem 1rem;\n  }\n  \n  /* Highlight text (e.g., \"1 WEEK\") */\n  .highlight-text {\n    font-size: 3rem;\n    font-weight: 700;\n    background-color: #dcca98; /* Light gold background */\n    color: #144044;            /* Dark text */\n    padding: 0.3rem 0.6rem;\n    border-radius: 4px;\n    margin-bottom: 0.4rem;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n  }\n  \n  /* Main text (e.g., \"FREE TRIAL\") */\n  .main-text {\n    font-size: 2rem;   /* Larger for emphasis */\n    font-weight: 800;\n    line-height: 1.2;\n  }\n  \n  /* CTA Button container (just for spacing) */\n  .cta-wrapper {\n    margin-top: 1rem;\n  }\n  \n  /* CTA Button styles - Light gold background, dark text */\n  .cta-button {\n    background-color: #dcca98;\n    color: #144044;\n    border: none;\n    padding: 0.8rem 1.4rem;\n    border-radius: 4px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-size: 1rem; /* Increase for bigger button */\n  }\n  \n  .cta-button:hover {\n    background-color: #c0b085; /* Slightly darker gold on hover */\n  }\n  \n  /* \n     Dismiss (X) button in the top-right corner of the banner\n     (technically top-right corner after skew, so might appear offset—adjust as needed)\n  */\n  .dismiss-button {\n    position: absolute;\n    top: 0.5rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    color: #dcca98;\n    font-size: 1.5rem;\n    cursor: pointer;\n    transition: color 0.2s ease;\n    z-index: 4; /* above shapes and text container */\n  }\n  \n  .dismiss-button:hover {\n    color: #ffffff;\n  }\n  \n  /* \"FOR A LIMITED TIME\" label on the side of the banner */\n  .limited-time-text {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: rotate(-30deg) translateY(50%);\n    transform-origin: center;\n  \n    background-color: #dcca98; /* Light gold */\n    color: #144044;           /* Dark greenish tone */\n    font-weight: 700;\n    padding: 0.4rem 0.6rem;\n    border-radius: 4px;\n    letter-spacing: 1px;\n    z-index: 3; /* Above shapes but below the .text-container */\n  }\n  \n  /* ---------------------------------\n     MEDIA QUERIES FOR RESPONSIVENESS\n     --------------------------------- */\n  \n  /* Tablet breakpoint (max-width: 768px) */\n  @media (max-width: 768px) {\n    .trial-banner {\n      /* Move the banner up or down for smaller screens if needed */\n      top: 15%;\n      padding: 1rem;\n    }\n  \n    .banner-content {\n      min-height: 120px; /* Slightly smaller height */\n    }\n  \n    /* Reduce shape sizes or hide them if they overlap content */\n    .circle1 {\n      width: 90px;\n      height: 90px;\n      top: 10%;\n      left: 10%;\n    }\n    .circle2 {\n      width: 60px;\n      height: 60px;\n      bottom: 10%;\n      right: 10%;\n    }\n    .blob {\n      width: 280px;\n      height: 120px;\n    }\n  \n    /* Scale text sizes slightly */\n    .highlight-text {\n      font-size: 2rem;\n    }\n    .main-text {\n      font-size: 1.6rem;\n    }\n    .cta-button {\n      font-size: 0.9rem;\n      padding: 0.6rem 1rem;\n    }\n  \n    /* Adjust \"LIMITED TIME\" label */\n    .limited-time-text {\n      font-size: 1.3rem;\n      transform: rotate(-25deg) translateY(50%);\n    }\n  }\n  \n  /* Mobile breakpoint (max-width: 480px) */\n  @media (max-width: 480px) {\n    .trial-banner {\n      padding: 1rem;\n    }\n  \n    .banner-content {\n      min-height: 100px;\n    }\n  \n    /* If shapes cause overlap on mobile, you can hide them entirely\n       or drastically reduce their size. Example: \n       .circle1, .circle2, .blob { display: none; }\n    */\n    .circle1 {\n      width: 60px;\n      height: 60px;\n      top: 10%;\n      left: 5%;\n    }\n    .circle2 {\n      width: 40px;\n      height: 40px;\n      bottom: 5%;\n      right: 5%;\n    }\n    .blob {\n      width: 200px;\n      height: 100px;\n    }\n  \n    /* Scale text further on mobile */\n    .highlight-text {\n      font-size: 0.8rem;\n    }\n    .main-text {\n      font-size: 1.4rem;\n    }\n    .cta-button {\n      font-size: 0.8rem;\n      padding: 0.5rem 0.8rem;\n    }\n  \n    .dismiss-button {\n      font-size: 1.2rem;\n      top: 0.3rem;\n    }\n  \n    /* Adjust \"LIMITED TIME\" label for mobile */\n    .limited-time-text {\n      font-size: 0.7rem;\n      transform: rotate(-20deg) translateY(50%);\n    }\n  }\n  \n  /* \n     If your page content is hidden behind the banner, \n     add some top padding to the body or main container. \n     Adjust according to the final banner height.\n  */\n  body {\n    font-family: sans-serif;\n    /* Example:\n    padding-top: 200px; \n    */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
